import axios from 'axios';

export const getDetailsFromIpAddress = async (ip) => {
    const res = await axios.get(`https://ipapi.co/${ip}/json`);
    return res.data
}
